import React from 'react';
import Sidebar from '../Sidebar/Sidebar';
import "./NotFound.scss";

const NotFound = ()=>{



    return(
        <div>
            <Sidebar />
           <div className='text'>In Developing...</div> 
        </div>
        
    )
}

export default NotFound;